import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createClaimantDetailsAPI,
  updateClaimantDetailsAPI,
  deleteClaimantDetailsAPI,
  getClaimantDetailsAPI,
  getClaimantsByCaseIDAPI,
  uploadClaimantDocumentAPI,
  updateClaimantDocumentAPI,
  deleteClaimantDocumentAPI,
  getClaimantDocumentsAPI,
} from "../../../api/claimantDetails_api";

// ============================================================================
// ASYNC THUNKS
// ============================================================================

// NOTE: getClaimantsByCaseIDAction is used after create/update to refresh list
export const getClaimantsByCaseIDAction = createAsyncThunk(
  "claimantDetails/getClaimantsByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getClaimantsByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Create Claimant Details
 */
export const createClaimantDetailsAction = createAsyncThunk(
  "claimantDetails/createClaimantDetails",
  async (claimantData, { rejectWithValue }) => {
    const response = await createClaimantDetailsAPI(claimantData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Update Claimant Details
 */
export const updateClaimantDetailsAction = createAsyncThunk(
  "claimantDetails/updateClaimantDetails",
  async ({ claimantDetailsID, claimantData }, { rejectWithValue }) => {
    const response = await updateClaimantDetailsAPI(
      claimantDetailsID,
      claimantData,
    );
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Delete Claimant Details
 */
export const deleteClaimantDetailsAction = createAsyncThunk(
  "claimantDetails/deleteClaimantDetails",
  async (claimantDetailsID, { rejectWithValue }) => {
    const response = await deleteClaimantDetailsAPI(claimantDetailsID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return claimantDetailsID;
  },
);

/**
 * Get Claimant Details
 */
export const getClaimantDetailsAction = createAsyncThunk(
  "claimantDetails/getClaimantDetails",
  async (claimantDetailsID, { rejectWithValue }) => {
    const response = await getClaimantDetailsAPI(claimantDetailsID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Get All Claimants for a Case
 */
// (Definition moved above so thunks can dispatch it after create/update)

/**
 * Upload Claimant Document
 */
export const uploadClaimantDocumentAction = createAsyncThunk(
  "claimantDetails/uploadDocument",
  async (formData, { rejectWithValue }) => {
    const response = await uploadClaimantDocumentAPI(formData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Update Claimant Document
 */
export const updateClaimantDocumentAction = createAsyncThunk(
  "claimantDetails/updateDocument",
  async ({ documentID, documentData }, { rejectWithValue }) => {
    const response = await updateClaimantDocumentAPI(documentID, documentData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

/**
 * Delete Claimant Document
 */
export const deleteClaimantDocumentAction = createAsyncThunk(
  "claimantDetails/deleteDocument",
  async (documentID, { rejectWithValue }) => {
    const response = await deleteClaimantDocumentAPI(documentID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return documentID;
  },
);

/**
 * Get Claimant Documents
 */
export const getClaimantDocumentsAction = createAsyncThunk(
  "claimantDetails/getDocuments",
  async (claimantDetailsID, { rejectWithValue }) => {
    const response = await getClaimantDocumentsAPI(claimantDetailsID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
